import { TeamSpot } from '@optools/components/team-spot';
import { Badge } from '@optools/components/ui/badge';
import { Card } from '@optools/components/ui/card';
import { cn } from '@optools/components/ui/utils';
import { Team } from '@optools/services/statsapi/types';
import { ComponentProps, ReactNode } from 'react';

export interface TeamConfigCardProps extends ComponentProps<'div'> {
  team: Team | undefined;
  teamId: number | null | undefined;
}

export function TeamConfigCard({
  children,
  className,
  team,
  teamId,
  ...props
}: TeamConfigCardProps) {
  return (
    <Card className={cn('p-4', className)} {...props}>
      <div className="mb-2 flex items-center gap-2">
        <TeamSpot id={teamId} showAbbreviation={false} size={64} />
        <div>
          <h2 className="mb-1 text-sm font-bold">{team?.name}</h2>
          <div className="flex flex-wrap items-center gap-2">
            <p className="text-xs font-bold">{team?.abbreviation}</p>
            <Badge variant="outline">ID: {teamId}</Badge>
          </div>
        </div>
      </div>
      {children}
    </Card>
  );
}

export function TeamConfigGrid({ children }: { children: ReactNode }) {
  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-4">{children}</div>
  );
}
